import { CUJStatus, IMonitorModuleConfig, MonitorModule, Region } from '@pns-fe/sdk-common-modules';
import { REGION_MAP } from '../consent';

interface InitSlardarParams {
  idcRegion: string;
  tenantId: string;
  scmVersion: string;
  appId: number;
  monitorConfig?: IMonitorModuleConfig;
}

let slardarInitialized = false;

export let monitorModule: MonitorModule | undefined = undefined;

const defaultMonitorConfig: IMonitorModuleConfig = {
  slardar: {
    domain: 'https://mon.tiktokv.com',
    pluginPathPrefix:
      'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins',
  },
};

export async function initSlardar({
  idcRegion,
  tenantId,
  scmVersion,
  appId,
  monitorConfig = defaultMonitorConfig,
}: InitSlardarParams): Promise<void> {
  if (slardarInitialized) {
    return;
  }

  slardarInitialized = true;

  try {
    monitorModule = new MonitorModule();

    const monitorConfigWithoutTea = {
      ...monitorConfig,
      tea: false,
    } as const;

    monitorModule.init(monitorConfigWithoutTea, {
      bid: 'pns_cookie_banner_slardar',
      appVersion: scmVersion,
      appId,
      tenant: tenantId,
      region: (REGION_MAP[idcRegion] || REGION_MAP.ALL_SG) as Region,
    });

    monitorModule.reportCUJ('load_cookie_banner', CUJStatus.START, { stepName: 'FINISH' });
  } catch (err) {
    console.warn('initSlardar failed: ', err);
  }
}
